import { render, staticRenderFns } from "./BannerUploadTab.vue?vue&type=template&id=6655b81e"
import script from "./BannerUploadTab.vue?vue&type=script&lang=js"
export * from "./BannerUploadTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports